import * as React from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function SelectedEventItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const event = props.event;

  return (
    <div className="selected-event-item" onClick={() => props.removeSelectedEventItem(event)}>
      <div className="selected-event-item-image">
        <img src={`https://${system.subdomain}.companyapp.net${event.field_featured_image}`} />
      </div>
      <div className="selected-event-item-title">{decode(event.title)}</div>
    </div>
  );
}
